
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/properties/[cityslug]",
      function () {
        return require("private-next-pages/properties/[cityslug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/properties/[cityslug]"])
      });
    }
  